import { render } from "./deliverGoodsModule.vue?vue&type=template&id=88c72df6"
import script from "./deliverGoodsModule.vue?vue&type=script&lang=js"
export * from "./deliverGoodsModule.vue?vue&type=script&lang=js"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__